import { useState, useEffect } from 'react'

export default function MiniAppConfig() {
  const [config, setConfig] = useState({
    enableVideoShowcase: false,
    enableStoryVideo: false,
    aiCreationEnabled: false,
    canPurchase: true
  })
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')

  const API = '/cms/api/miniapp-config'

  useEffect(() => {
    fetch(API)
      .then(r => r.json())
      .then(d => {
        if (d.success) setConfig(d.data)
        setLoading(false)
      })
      .catch(() => { setLoading(false); setMessage('加载失败') })
  }, [])

  const toggle = (key) => {
    const newVal = !config[key]
    setSaving(true)
    fetch(API, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ [key]: newVal })
    })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setConfig(d.data)
          const labels = {
            enableVideoShowcase: '首页视频样片',
            enableStoryVideo: '故事详情页视频',
            aiCreationEnabled: 'AI动画工坊',
            canPurchase: '购买入口'
          }
          setMessage(`${labels[key] || key}已${newVal ? '开启 ✅' : '关闭 ❌'}`)
        } else {
          setMessage('保存失败')
        }
        setSaving(false)
        setTimeout(() => setMessage(''), 3000)
      })
      .catch(() => { setSaving(false); setMessage('网络错误') })
  }

  const allOff = () => {
    if (!window.confirm('确认关闭所有功能开关？\n\n关闭后将隐藏视频、AI工坊、购买等所有入口。\n用于提交微信审核前使用。')) return
    setSaving(true)
    const body = { enableVideoShowcase: false, enableStoryVideo: false, aiCreationEnabled: false, canPurchase: false }
    fetch(API, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(d => {
        if (d.success) { setConfig(d.data); setMessage('🔒 已切换为审核模式') }
        else setMessage('操作失败')
        setSaving(false)
        setTimeout(() => setMessage(''), 3000)
      })
      .catch(() => { setSaving(false); setMessage('网络错误') })
  }

  const allOn = () => {
    if (!window.confirm('确认开启所有功能开关？\n\n用于审核通过后恢复正常运营。')) return
    setSaving(true)
    const body = { enableVideoShowcase: true, enableStoryVideo: true, aiCreationEnabled: true, canPurchase: true }
    fetch(API, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(d => {
        if (d.success) { setConfig(d.data); setMessage('🔓 已恢复正常运营') }
        else setMessage('操作失败')
        setSaving(false)
        setTimeout(() => setMessage(''), 3000)
      })
      .catch(() => { setSaving(false); setMessage('网络错误') })
  }

  const Switch = ({ checked, onChange, disabled }) => (
    <label style={{ position: 'relative', display: 'inline-block', width: 44, height: 24, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} style={{ display: 'none' }} />
      <span style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: checked ? '#52c41a' : '#ccc', borderRadius: 12, transition: '0.3s' }}></span>
      <span style={{ position: 'absolute', top: 2, left: checked ? 22 : 2, width: 20, height: 20, background: '#fff', borderRadius: '50%', transition: '0.3s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }}></span>
    </label>
  )

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>加载中...</div>

  const allOffNow = !config.enableVideoShowcase && !config.enableStoryVideo && !config.aiCreationEnabled && config.canPurchase === false
  const allOnNow = config.enableVideoShowcase && config.enableStoryVideo && config.aiCreationEnabled && config.canPurchase !== false

  return (
    <div style={{ padding: 24, maxWidth: 600, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 8 }}>📱 小程序配置</h2>
      <p style={{ color: '#666', marginBottom: 24, fontSize: 14 }}>
        修改后立即生效，无需重新提审小程序
      </p>

      {message && (
        <div style={{ padding: '10px 16px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 6, marginBottom: 16, color: '#389e0d' }}>
          {message}
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 1px 4px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        {/* 📹 视频类 */}
        <div style={{ padding: '8px 20px', background: '#fafafa', fontSize: 12, color: '#999', fontWeight: 600, borderBottom: '1px solid #f0f0f0' }}>📹 视频类</div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }}>
          <div>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>🎬 首页动画影片样片</div>
            <div style={{ fontSize: 13, color: '#888' }}>控制首页 Banner 下方"动画影片"样片区显示/隐藏</div>
          </div>
          <Switch checked={config.enableVideoShowcase} onChange={() => toggle('enableVideoShowcase')} disabled={saving} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }}>
          <div>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>🌈 故事详情页视频播放器</div>
            <div style={{ fontSize: 13, color: '#888' }}>控制有视频的故事详情页底部视频播放器显示/隐藏</div>
          </div>
          <Switch checked={config.enableStoryVideo} onChange={() => toggle('enableStoryVideo')} disabled={saving} />
        </div>

        {/* 🤖 AI 功能 */}
        <div style={{ padding: '8px 20px', background: '#fafafa', fontSize: 12, color: '#999', fontWeight: 600, borderBottom: '1px solid #f0f0f0' }}>🤖 AI 功能</div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #f0f0f0' }}>
          <div>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>🤖 AI 动画工坊</div>
            <div style={{ fontSize: 13, color: '#888' }}>控制首页"画作变动画"创作工坊入口显示/隐藏</div>
          </div>
          <Switch checked={config.aiCreationEnabled} onChange={() => toggle('aiCreationEnabled')} disabled={saving} />
        </div>

        {/* 💰 支付/购买 */}
        <div style={{ padding: '8px 20px', background: '#fafafa', fontSize: 12, color: '#999', fontWeight: 600, borderBottom: '1px solid #f0f0f0' }}>💰 支付/购买</div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px' }}>
          <div>
            <div style={{ fontWeight: 500, marginBottom: 4 }}>🛒 购买入口（全部）</div>
            <div style={{ fontSize: 13, color: '#888' }}>控制所有页面"立即购买"按钮。关闭后显示"敬请期待"</div>
          </div>
          <Switch checked={config.canPurchase !== false} onChange={() => toggle('canPurchase')} disabled={saving} />
        </div>
      </div>

      {/* 一键操作 */}
      <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
        <button
          onClick={allOff}
          disabled={saving || allOffNow}
          style={{
            flex: 1, padding: '10px 0', border: 'none', borderRadius: 6,
            background: allOffNow ? '#ffcccc' : '#ff4d4f', color: '#fff',
            fontSize: 14, fontWeight: 500, cursor: allOffNow ? 'not-allowed' : 'pointer',
            opacity: allOffNow ? 0.6 : 1
          }}
        >
          🔒 一键关所有·提审模式
        </button>
        <button
          onClick={allOn}
          disabled={saving || allOnNow}
          style={{
            flex: 1, padding: '10px 0', border: 'none', borderRadius: 6,
            background: allOnNow ? '#d4edda' : '#52c41a', color: '#fff',
            fontSize: 14, fontWeight: 500, cursor: allOnNow ? 'not-allowed' : 'pointer',
            opacity: allOnNow ? 0.6 : 1
          }}
        >
          🔓 一键开所有·正常运营
        </button>
      </div>

      <div style={{ marginTop: 16, fontSize: 13, color: '#999', lineHeight: 1.8, background: '#fafafa', padding: 12, borderRadius: 6 }}>
        <div>💡 当前状态：</div>
        <div>📹 视频：样片 <strong>{config.enableVideoShowcase ? '✅' : '❌'}</strong> | 详情视频 <strong>{config.enableStoryVideo ? '✅' : '❌'}</strong></div>
        <div>🤖 AI：动画工坊 <strong>{config.aiCreationEnabled ? '✅' : '❌'}</strong></div>
        <div>💰 购买：全部入口 <strong>{config.canPurchase !== false ? '✅' : '❌'}</strong></div>
        <div style={{ marginTop: 4, padding: '4px 8px', borderRadius: 4,
          background: allOffNow ? '#fff2f0' : allOnNow ? '#f6ffed' : '#fffbe6',
          color: allOffNow ? '#cf1322' : allOnNow ? '#389e0d' : '#d48806',
          display: 'inline-block'
        }}>
          {allOffNow ? '🔴 审核模式' : allOnNow ? '🟢 正常运营' : '⚪ 自定义模式'}
        </div>
      </div>
    </div>
  )
}
